/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

Vue.prototype.$http = axios;

import store from "./vuex/store";
import VueAnalytics from "vue-ua";
import VueFacebookPixel from 'vue-analytics-facebook-pixel';
import Order from './components/order.vue';

/*
 Vue.config.devtools = false;
 Vue.config.debug = false;
 Vue.config.silent = true;
 */

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
    apiKey: 'f0aca5a982ca97ddddc02ea786c87816',
    plugins: [new BugsnagPluginVue()],
});


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the body of the page. From here, you may begin adding components to
 * the application, or feel free to tweak this setup for your needs.
 */

Vue.filter('stripe-price', function (value) {
    return value / 100;
});

Vue.filter('credit-card', function (value) {

    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || '';
    var parts = [];
    for (var i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4))
    }
    if (parts.length) {
        return parts.join(' ')
    } else {
        return value
    }
});

Vue.use(VueAnalytics, {
    appName: 'Naesbyhoved Skov Shop',
    appVersion: '1.0',
    trackingId: 'UA-57510634-1',
    debug: true
});

Vue.use(VueFacebookPixel);

const app = new Vue({
    store,
    components:{
        'order':Order
    },
    mounted(){
        Vue.analytics.fbq.init('1653540894674832');
    }
}).$mount('#vue');

const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(app)

/*window.polyfillsAreLoaded = function () {

    const app = new Vue({
        store,
        components:{
            'order':Order
        },
        mounted(){
            Vue.analytics.fbq.init('1653540894674832');
        }
    }).$mount('#vue');

    const bugsnagVue = Bugsnag.getPlugin('vue')
    bugsnagVue.installVueErrorHandler(app)
};*/
